export const TOAST = {
  CHANGES_SAVED: "Changes saved",
  GENERIC_ERROR: "Something went wrong. Please try again.",
  COMING_SOON: "This feature is coming soon",
  ACCOUNT_JOINED: "You've joined the estate",
} as const;
